import { createContext } from 'react';

const tableContext = createContext({});

export { tableContext };
